var CoordinateShape = require('./coordinate');

module.exports = CoordinateShape.extend({

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/highlight.js
 ** module id = 288
 ** module chunks = 0
 **/